export const FETCH_ARTICLE_BLOB = 'ARTICLES/FETCH_BLOB';
export const FETCH_ARTICLE_BLOB_SUCCESS = 'ARTICLES/FETCH_BLOB_SUCCESS';
export const FETCH_ARTICLE_BLOB_ERROR = 'ARTICLES/FETCH_BLOB_ERROR';
